import React from 'react';

export const CompanyDetailSummary = () => {
  const comapnySumarry = [
    { id: 1, size: '200+', title: 'Happy Users' },
    { id: 2, size: '7000+', title: 'Orders Completed' },
    { id: 3, size: '26+', title: 'Currency Exchanged' },
    { id: 4, size: '24', title: 'Hour Support Services' },
  ];
  return (
    <section className='bg-s-wh'>
      <div className='grid sm:grid-cols-2 md:grid-cols-4 gap-y-8 max-w-[1440px] py-12 mx-auto'>
        {comapnySumarry.map((data) => (
          <div key={data.id} className='text-center space-y-2 lg:space-y-4'>
            <h2 className='font-semibold text-3xl'>{data.size}</h2>
            <p>{data.title}</p>
          </div>
        ))}
      </div>
    </section>
  );
};
